export const de = {
    languages: {
        cs: 'Tschechisch',
        de: 'Deutsch',
        en: 'Englisch',
        es: 'Spanisch',
        fr: 'Französisch',
        hr: 'Kroatisch',
        hu: 'Ungarisch',
        it: 'Italienisch',
        nl: 'Niederländisch',
        pl: 'Polnisch',
        ru: 'Russisch',
        sk: 'Slowakisch',
        tr: 'Türkisch',
        uk: 'Ukrainisch',
        undefined: 'Keine Untertitel',
    },
    player: {
        content: {
            notFound: { title: 'Fehler beim Laden des Medienelements 😞' },
        },
        controls: {
            backwards: { title: '10s zurück' },
            buffering: { title: 'Lädt...' },
            captions: { title: 'Untertitel' },
            forwards: { title: '10s nach vorne' },
            fullscreen: { title: 'Vollbild' },
            pause: { title: 'Pausieren' },
            play: { title: 'Abspielen' },
            playlist: { title: 'Playlist' },
            volume: { title: 'Lautstärke' },
        },
    },
};
